"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotAuthorizedException = exports.NotAuthorizedExceptionName = exports.UserNotFoundException = exports.UserNotFoundExceptionName = exports.PasswordResetRequiredException = exports.PasswordResetRequiredExceptionName = exports.UserNotConfirmedException = exports.UserNotConfirmedExceptionName = void 0;
/**
 * Occurs when attempting to sign in to an account without a verified email.
 */
exports.UserNotConfirmedExceptionName = "UserNotConfirmedException";
class UserNotConfirmedException extends Error {
    constructor(message = "User is not confirmed.") {
        super(message);
        this.message = message;
        this.name = exports.UserNotConfirmedExceptionName;
    }
}
exports.UserNotConfirmedException = UserNotConfirmedException;
/**
 * Occurs when attempting to sign in to an account when the account has a forced password reset.
 */
exports.PasswordResetRequiredExceptionName = "PasswordResetRequiredException";
class PasswordResetRequiredException extends Error {
    constructor(message = "Password reset required for the user.") {
        super(message);
        this.message = message;
        this.name = exports.PasswordResetRequiredExceptionName;
    }
}
exports.PasswordResetRequiredException = PasswordResetRequiredException;
exports.UserNotFoundExceptionName = "UserNotFoundException";
class UserNotFoundException extends Error {
    constructor(message = "Username not found.") {
        super(message);
        this.message = message;
        this.name = exports.UserNotFoundExceptionName;
    }
}
exports.UserNotFoundException = UserNotFoundException;
exports.NotAuthorizedExceptionName = "NotAuthorizedException";
class NotAuthorizedException extends Error {
    constructor(message = "Incorrect password.") {
        super(message);
        this.message = message;
        this.name = exports.NotAuthorizedExceptionName;
    }
}
exports.NotAuthorizedException = NotAuthorizedException;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQVdTQXV0aEVycm9ycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9BV1NBdXRoRXJyb3JzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBOztHQUVHO0FBQ1UsUUFBQSw2QkFBNkIsR0FDeEMsMkJBQTJCLENBQUM7QUFDOUIsTUFBYSx5QkFBMEIsU0FBUSxLQUFLO0lBRWxELFlBQTRCLFVBQWtCLHdCQUF3QjtRQUNwRSxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUM7UUFEVyxZQUFPLEdBQVAsT0FBTyxDQUFtQztRQUR0RCxTQUFJLEdBQVcscUNBQTZCLENBQUM7SUFHN0QsQ0FBQztDQUNGO0FBTEQsOERBS0M7QUFFRDs7R0FFRztBQUNVLFFBQUEsa0NBQWtDLEdBQzdDLGdDQUFnQyxDQUFDO0FBQ25DLE1BQWEsOEJBQStCLFNBQVEsS0FBSztJQUV2RCxZQUNrQixVQUFrQix1Q0FBdUM7UUFFekUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDO1FBRkMsWUFBTyxHQUFQLE9BQU8sQ0FBa0Q7UUFGM0QsU0FBSSxHQUFXLDBDQUFrQyxDQUFDO0lBS2xFLENBQUM7Q0FDRjtBQVBELHdFQU9DO0FBRVksUUFBQSx5QkFBeUIsR0FBVyx1QkFBdUIsQ0FBQztBQUN6RSxNQUFhLHFCQUFzQixTQUFRLEtBQUs7SUFFOUMsWUFBNEIsVUFBa0IscUJBQXFCO1FBQ2pFLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQztRQURXLFlBQU8sR0FBUCxPQUFPLENBQWdDO1FBRG5ELFNBQUksR0FBVyxpQ0FBeUIsQ0FBQztJQUd6RCxDQUFDO0NBQ0Y7QUFMRCxzREFLQztBQUVZLFFBQUEsMEJBQTBCLEdBQVcsd0JBQXdCLENBQUM7QUFDM0UsTUFBYSxzQkFBdUIsU0FBUSxLQUFLO0lBRS9DLFlBQTRCLFVBQWtCLHFCQUFxQjtRQUNqRSxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUM7UUFEVyxZQUFPLEdBQVAsT0FBTyxDQUFnQztRQURuRCxTQUFJLEdBQVcsa0NBQTBCLENBQUM7SUFHMUQsQ0FBQztDQUNGO0FBTEQsd0RBS0MifQ==